import './Styles/Home.css';

import { useState } from 'react';
import { Flex, Text, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BiChevronUp, BiChevronDown } from 'react-icons/bi';

const OpenHours = (props)=> {

    const [isDropdownOpen, setDropdownOpen] = useState(false);  

    const hourToTimestamp = (hour_as_string) => {        

        if( !hour_as_string )
            return 0;

        const [hour, minute] = hour_as_string.split(':');

        if( minute )
            return ((hour*60)+parseInt(minute));
        else
            return (hour*60);
    }

    const getHoursFromString = (open_hours_as_string) => {
        const hour_intervals = open_hours_as_string.split(',');
        const hours_as_strings = [];
        const hours = [];
        
        for( var i=0; i < hour_intervals.length; i++ ) 
            hours_as_strings.push( ...hour_intervals[i].split('-') );
        
        for( i=0; i < hours_as_strings.length; i++ ) 
            hours.push( hourToTimestamp(hours_as_strings[i].toString()) );
            
        
        return hours;
    }

    const isCurrentTimeWithinIntervals = ( intervals_as_string ) => {
        const currentHour = new Date().getHours();
        const currentMinute = new Date().getMinutes();
        const hourMinAsTimestamp = currentHour*60+currentMinute;
        const hoursInterval = getHoursFromString(intervals_as_string);
        let isHourWithin = false;
    
        for( var i=0; i < hoursInterval.length; i+=2)
            isHourWithin = isHourWithin || ( hourMinAsTimestamp >= hoursInterval[i] && hourMinAsTimestamp <= hoursInterval[i+1] );
        
        return isHourWithin;
    }
    
    const { t } = useTranslation();

    const weekDays = ['sun','mon','tue','wed','thu','fri','sat'];
    const dayNumber = new Date().getDay();
    const today = weekDays[ dayNumber ];
    let isRestaurantOpen = false;
    let nextOpenDay = "";

    for( let i= 0; i < 7; i++ )
        if( props.timeTable[ weekDays[(dayNumber + i) % 7] ].length > 0 ) {
            nextOpenDay = weekDays[ (dayNumber + i) % 7];
            break;
        }
    
    const nextOpenDayHours = props.timeTable[nextOpenDay].split(',') || "";
    
    if( props.timeTable[today] )
        isRestaurantOpen = isCurrentTimeWithinIntervals(props.timeTable[today]);

    return( 
        <Flex width="92%" ml={4} mb={1} mt={3} direction="column" alignItems="center">
            <Flex width="100%" /**borderBottom="1px solid" borderColor="separator"**/>
                <Text fontSize="xl" fontWeight="medium" className="open_hours_title" display="inline-block" mt={4}>
                    {t("whenOpen")}
                </Text>
                {
                    isRestaurantOpen ? 
                    <Text fontSize="normal" fontWeight="medium" color="#4BAC61" className="open_hours_title"  display="inline-block" ml="auto" mt={4} mr={3} >
                        {t("open")}
                    </Text> :
                    <Text fontSize="normal" fontWeight="medium" color="#680000" className="open_hours_title"  display="inline-block" mt={4} ml="auto" mr={3} >  
                        {t("closed")}
                    </Text>
                }
            </Flex>
            <Flex w="100%" border="1px solid" ml={4} mr={4} alignItems="center" 
                  justifyContent={ !isDropdownOpen ? "flex-start":"flex-end" } pt={1} pb={1} borderColor="separator" borderRadius="md" onClick={ ()=> { setDropdownOpen( !isDropdownOpen ) } }>
                    
            { !isDropdownOpen &&
                <>
                    <Text ml={4} fontWeight={ today === nextOpenDay ? "bold":"normal" } color={ today===nextOpenDay ? "highlight":"lightblack"}>
                        { t(nextOpenDay) }
                    </Text>
                     
                    <Text display="inline-block" alignSelf="flex-end"
                          fontWeight={ today === nextOpenDay ? "bold":"normal" }
                          ml="auto"
                          color={ today===nextOpenDay ? "highlight":"lightblack"}>
                                {
                                    nextOpenDayHours.map( (interval, index) => interval + ((index < nextOpenDayHours.length-1) ? ' - ': ' ') ) 
                                }
                    </Text>
                </>
            }   

                    <IconButton variant="solid" as={ isDropdownOpen ? BiChevronUp:BiChevronDown} border="1px solid" borderColor="separator" size="xs" alignSelf="flex-end" ml={4} mr={2}
                    _focus={{ bg: "#4BAC61" }}
                    isRound/>
            </Flex>
            <Flex width="100%" direction="column" maxWidth="85vmin" mt={1}>
               {    isDropdownOpen && 
                   ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'].map( (day, index) => {

                            let todaysOpenHours = props.timeTable[day].split(',');

                            return (
                                ( props.timeTable[day] ) ?
                                    <Flex width="100%" mb={1} key={index}>
                                        
                                            <Text display="inline-block" fontWeight={ day===today ? "bold":"normal" }
                                                                                          color={ day===today ? "highlight":"lightblack" } >
                                                {t(day)}
                                            </Text>
                                            
                                            
                                            <Flex direction="column" ml="auto">
                                                <Text display="inline-block" alignSelf="flex-end" key={index} 
                                                       fontWeight={ day===today ? "bold":"normal" }
                                                       color={ day===today ? "highlight":"lightblack" }>
                                                {
                                                    todaysOpenHours.map( (interval, index) => interval + ((index < todaysOpenHours.length-1) ? ' - ': ' ') ) 
                                                }
                                                </Text>
                                            </Flex>

                                    </Flex> :null 
                                );
                        })
                }
 
            </Flex>
        </Flex>
    );
}

export default OpenHours;